import { render, staticRenderFns } from "./commonRouteInfoList.vue?vue&type=template&id=6103778e&scoped=true"
import script from "./commonRouteInfoList.vue?vue&type=script&lang=js"
export * from "./commonRouteInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6103778e",
  null
  
)

export default component.exports